import { useEffect } from 'react';

import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { LexExperimentEvents_EventType as LexExperimentsEventType } from '__generated__/graphql-types';

import type {
  QueryByEventTypeQuery,
  QueryByEventTypeQueryVariables,
} from 'bundles/lex-experiment-events/queries/__generated__/queryByEventType';
import queryByEventTypeQuery from 'bundles/lex-experiment-events/queries/queryByEventType.graphql';

type UseQueryByEventTypeProps = {
  eventType: LexExperimentsEventType;
  courseId?: string;
  skip?: boolean;
};

export const useQueryByEventType = ({ eventType, courseId, skip = false }: UseQueryByEventTypeProps) => {
  const { loading, error, data, refetch } = useQuery<QueryByEventTypeQuery, QueryByEventTypeQueryVariables>(
    queryByEventTypeQuery,
    {
      variables: { eventType, courseId },
      context: { clientName: 'gatewayGql' },
      skip,
    }
  );

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return {
    loading,
    error,
    data,
    refetch,
  };
};
